import { render, staticRenderFns } from "./DeleteWebsite.vue?vue&type=template&id=3114a496&"
import script from "./DeleteWebsite.vue?vue&type=script&lang=js&"
export * from "./DeleteWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports